<template>
  <unauthorized-view></unauthorized-view>
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
export default {
  components: {
    UnauthorizedView: asyncComponentFactory(`views/general/Unauthorized.vue`, true),
  },
  layout: {
    component: "boxy",
    params: {
      cardWidth: "xs"
    },
  },
  meta: "core.404.metaTitle",
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>
